// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ym9d","left":"styles_left__roEBI"};